import { Navigation } from './Navigation';
import { Logo } from './Logo';
import { useEffect, useState } from 'react';

interface HeaderProps {
  variant?: 'light' | 'dark';
}

export const Header = ({ variant = 'dark' }: HeaderProps): JSX.Element => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobile, setIsMobile] = useState(() => {
    // Initialize mobile state correctly on first render
    if (typeof window !== 'undefined') {
      return window.innerWidth < 768;
    }
    return false;
  });
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    // Set initialized after first render to prevent initial transition
    setIsInitialized(true);
    checkMobile();
    window.addEventListener('resize', checkMobile);

    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 50);
    };

    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('resize', checkMobile);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header className="fixed top-0 left-0 right-0 z-50">
      <div className={`${isMobile ? (isScrolled ? 'w-full px-4' : 'w-full px-4') : 'w-[90%]'} mx-auto ${isInitialized ? 'transition-[background-color,backdrop-filter,border-color,box-shadow,width,transform,height,padding-top,padding-bottom] duration-500 ease-in-out' : ''} ${
        isMobile && isScrolled 
          ? 'bg-white/70 backdrop-blur-md border border-white/20 shadow-lg h-[120px] pt-[65px] pb-4' 
          : isMobile 
            ? 'py-4 h-[72px]' 
            : 'py-6'
      }`}>
        <div className="flex items-center justify-between">
          <div className={`flex items-center ${isInitialized ? 'transition-all duration-500' : ''}`}>
            <Logo variant={variant} className="cursor-pointer w-fit h-fit" />
          </div>
          <div className={`${isInitialized ? 'transition-all duration-500' : ''} relative z-10`}>
            <Navigation variant={variant} />
          </div>
        </div>
      </div>
    </header>
  );
};